import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClienteComboInternoOutput, PedidoBaixaOnlineInternaOutput, PedidoConsultaInternaOutput, PedidoDetalheInternaOutput, PedidoPesoNrtOutput, PedidoRatInternaOutput, RastreamentoPedidoHistoricoInternoOutput } from 'src/app/@shared/models/consulta-detalhes-interno';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ConsultaDetalheInternaService {

  constructor(private http: HttpClient) { }

  getClientesConsultaDetalhadaInterna(): Observable<ClienteComboInternoOutput[]> {
    return this.http.get<ClienteComboInternoOutput[]>(`ConsultaDetalhadaInterna/SelecionarClientes`, httpOptions);
  }

  getConsultaDetalhadaPorNRT(pedidoid: string, clienteId?: number) {
    return this.http.get<PedidoConsultaInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaPorNRT/${pedidoid.replace(/\s/g, "")}/${clienteId || ""}`, httpOptions);
  }

  getConsultaDetalhadaPorConta(idConta: string, clienteId: number) {
    return this.http.get<PedidoConsultaInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaPorConta/${idConta.replace(/\s/g, "")}/${clienteId}`, httpOptions);
  }

  getConsultaDetalhadaPorCliente(codigoDeBarras: string, clienteId: number) {
    return this.http.get<PedidoConsultaInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaPorCliente/${codigoDeBarras.replace(/\s/g, "")}/${clienteId}`, httpOptions);
  }

  getConsultaDetalhadaPorNumeroRastreio(idconta: string, clienteId: number) {
    return this.http.get<PedidoConsultaInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaPorNumeroRastreio/${idconta.replace(/\s/g, "")}/${clienteId}`, httpOptions);
  }

  getConsultaDetalhadaPorAgenciaConta(agencia: string, conta: string, clienteId: number) {
    return this.http.get<PedidoConsultaInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaPorAgenciaConta/${agencia.replace(/\s/g, "")}/${conta.replace(/\s/g, "")}/${clienteId}`, httpOptions);
  }

  getConsultaDetalhadaPorNFE(nfe: string, clienteId: number) {
    return this.http.get<PedidoConsultaInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaPorNFE/${nfe.replace(/\s/g, "")}/${clienteId}`, httpOptions);
  }

  getConsultaDetalhadaPorDOC(doc: string, clienteId: number) {
    return this.http.get<PedidoConsultaInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaPorDocumento/${doc.replace(/\s/g, "")}/${clienteId}`, httpOptions);
  }

  getConsultaDetalhadaDadosGuia(pedidoid: number) {
    return this.http.get<PedidoDetalheInternaOutput>(`ConsultaDetalhadaInterna/SelecionarDadosGuia/${pedidoid}`, httpOptions);
  }

  getConsultaDetalhadaPesoNrt(pedidoid:number){
    return this.http.get<PedidoPesoNrtOutput[]>(`ConsultaDetalhadaInterna/SelecionarDadosPesoNRT/${pedidoid}`, httpOptions);
  }

  getConsultaDetalhadaDadosRAT(pedidoid:number){
    return this.http.get<PedidoRatInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarConsultaDetalhadaRAT/${pedidoid}`, httpOptions);
  }

  getConsultaDetalhadaDadosBaixaOnline(pedidoid: number) {
    return this.http.get<PedidoBaixaOnlineInternaOutput[]>(`ConsultaDetalhadaInterna/SelecionarDadosBaixaOnline/${pedidoid}`, httpOptions);
  }

  getHistoricoRastreamento(pedidoid: number) {
    return this.http.get<RastreamentoPedidoHistoricoInternoOutput[]>(`ConsultaDetalhadaInterna/RastreamentoPedido?pedidoId=${pedidoid}`, httpOptions);
  }

}
